import axios from 'axios'
import AuthService from '../Authentication/AuthService'

const AxiosService = axios.create({
  baseURL: '/api/',
})

AxiosService.interceptors.request.use(
  (request) => {
    if (AuthService.isAuthenticated()) {
      request.headers.authorization = AuthService.getAuthTokenHeader()
    }
    return request
  },
  (error) => Promise.reject(error)
)

AxiosService.interceptors.response.use(
  (response) => {
    let authorizationHeader = response.headers.authorization
    if (authorizationHeader) {
      AuthService.storeAuthToken(authorizationHeader)
    }
    return response.data
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 401 && !error.config.url.includes('auth/')) {
        return (window.location.href = '/logout')
      } else if (error.response.data.message === 'Gateway is not yet licensed') {
        return (window.location.href = '/setting/license')
      }
      error.response.message = error.response.data
      return Promise.reject(error.response)
    }
    return Promise.reject(error)
  }
)

export default AxiosService
